<mode-labeled-menu
  label="On the"
  [selected]="selected"
  [menuItems]="daysOfTheMonth"
  (menuChange)="handleMenuChange($event)"
  name="dayOfTheMonth"
  data-test="day-of-month-selector"
></mode-labeled-menu>
